// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const initPromoSlider = () => {
    const sliders = document.querySelectorAll('.block-promo__items');
    sliders.forEach(slider => {
        const swiper = new Swiper(slider, {
            navigation: {
                nextEl: slider.closest('.block-promo').querySelector('.block-promo__btn-next'),
                prevEl: slider.closest('.block-promo').querySelector('.block-promo__btn-prev'),
            },
            spaceBetween: 10,
            slidesPerView: 2,
            modules: [Navigation, Pagination],
            speed: 1000,
            breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    pagination: {
                        el: slider.closest('.block-promo').querySelector('.block-promo__pagination'),
                        type: 'bullets',
                        clickable: true,
                    },
                },
                768: {
                    slidesPerView: 2,
                }
            }
        });

        return swiper;
    });
};
initPromoSlider();
export default initPromoSlider;
